import styled from 'styled-components';

export const SimilaresContainer = styled.section`
    .swiper {
        width: 100%;
        z-index: 0;
    }

    .swiper-wrapper {
        padding-bottom: 60px;
    }

    .swiper-pagination {
        position: absolute;
    }

    .swiper-slide {
        /* Center slide text vertically */
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .swiper-button-prev,
    .swiper-button-next {
        position: absolute;
        z-index: 2;
        width: 0px;
        height: auto;
        cursor: pointer;
        color: rgba(0, 0, 0, 1);

        @media (max-width: 425px) {
            display: none;
        }
    }

    .swiper-button-prev::after,
    .swiper-button-next::after {
        font-size: 32px;
    }
`;
